/**
 * Middle column — Access `frmMatchingPSMatch_Stock_Sales` L=6540.
 *
 * Layout cột giữa theo Access (Top position):
 *   Allocating ID label (T=408) + match_id RO (T=792)
 *   "Allocating KG" mini-header (T=1140) + match_kg input (T=1440)
 *   "Note" label (T=1764) + note multiline (T=2088..3324)
 */
import { Stack, TextField, Typography } from '@mui/material'

const compactInputSx = { '& .MuiInputBase-input': { py: 0.5 } }
const matchIdInputSx = {
  '& .MuiInputBase-input': { py: 0.5, color: 'error.main', fontWeight: 700 },
}
const matchKgInputSx = {
  '& .MuiInputBase-input': { py: 0.5, fontWeight: 700 },
}

interface Props {
  matchId: number | null
  matchKg: string
  onMatchKgChange: (v: string) => void
  note: string
  onNoteChange: (v: string) => void
}

export default function MiddleColumnPanel({
  matchId,
  matchKg,
  onMatchKgChange,
  note,
  onNoteChange,
}: Props) {
  return (
    <Stack spacing={0.25} sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          color: 'error.main',
          lineHeight: 1.3,
          letterSpacing: 0.5,
          textTransform: 'uppercase',
        }}
      >
        Allocating ID
      </Typography>

      <TextField
        size="small"
        InputProps={{ readOnly: true, sx: { fontSize: '0.8rem' } }}
        value={matchId ?? ''}
        placeholder="(new)"
        fullWidth
        sx={matchIdInputSx}
      />

      {/* Floating mini-header above match_kg — Access ForeColor #0072BC, FontWeight 700 */}
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          color: 'primary.main',
          lineHeight: 1.3,
          letterSpacing: 0.5,
          textTransform: 'uppercase',
          mt: 0.25,
        }}
      >
        Allocating KG
      </Typography>

      <TextField
        size="small"
        value={matchKg}
        onChange={(e) => onMatchKgChange(e.target.value)}
        type="number"
        inputProps={{ step: 'any', min: 0 }}
        InputProps={{ sx: { fontSize: '0.8rem' } }}
        fullWidth
        sx={matchKgInputSx}
      />

      <Typography sx={{ fontSize: '0.78rem', mt: 0 }}>Note</Typography>

      <TextField
        size="small"
        value={note}
        onChange={(e) => onNoteChange(e.target.value)}
        InputProps={{ sx: { fontSize: '0.8rem' } }}
        fullWidth
        multiline
        minRows={2}
        maxRows={4}
      />
    </Stack>
  )
}
